import { INITIAL_APP_URL } from '@/constants/config';
import * as Sentry from '@sentry/react';
import { isDev } from '@winelidays/wld-tsx-2/utils';
import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

if (!isDev(process.env.APP_ENV)) {
  const ERROR_DEPTH = 5;
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    normalizeDepth: ERROR_DEPTH + 1,
    integrations: [
      // See docs for support of different versions of variation of react router
      // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration(),
    ],

    tracesSampleRate:
      process.env.SENTRY_SAMPLE_RATE != null ? parseFloat(process.env.SENTRY_SAMPLE_RATE) : 1,

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [/^\//, INITIAL_APP_URL.split('?')[0]],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    release: process.env.SENTRY_RELEASE,
    environment: process.env.SENTRY_ENVIRONMENT,
  });
}
